export default __webpack_public_path__ + "static/feature3-51aa8a72a6141d6fd511c611754d7484.png";